import React from 'react';
import PropTypes from 'prop-types';
/** Creates the headers and handles header clicks.
*/
class GridHeaders extends React.Component {
    constructor(props) {
        super(props);
        this.handleTDClick = this.handleTDClick.bind(this);
        this.handleTRClick = this.handleTRClick.bind(this);

        this.updateTableStyle = this.updateTableStyle.bind(this);
        this.clone = null;
    }
    getName() {
      return 'GridHeaders';
    }
    handleTDClick(props) {
      if(typeof this.props.onClick === 'function')
        this.props.onClick(props);
    }
    handleTRClick(props) {
      if(typeof this.props.onRowClick === 'function')
        this.props.onRowClick(props);
    }
    componentWillUpdate() {

    }
    updateTableStyle() {
      const thead = $(this.refs.head);
      const tds = $('td', thead);

      thead.removeAttr('style');

      tds.each(function() {
        $(this).removeAttr('style');
      });

      if(this.clone)
        $(this.clone).remove();

      this.clone = thead.clone();
      thead.parent().prepend(this.clone);
      $('td', this.clone).css({opacity : 0});

      tds.each(function() {
        $(this).css({ width : $(this).outerWidth() });
      });
      thead.css({
        'position' : 'absolute',
        'top' : '-1px'
      })

    }
    shouldComponentUpdate() {
      return true;
    }
    componentDidMount() {
      this.updateTableStyle();
      $(window).resize(this.updateTableStyle);
    }
    componentDidUpdate() {
      this.updateTableStyle();
    }
    render() {
      const schema = this.props.schema || [];
      const sortColumn = this.props.sortColumn;
      return <thead ref='head' className={this.props.theadClass}>
      <tr onClick={event => this.handleTRClick({schema, event})} className={this.props.trClass}>
        {schema.map((scheme, index) => {
          const {headerComponent, label, prop} = scheme;
          const Component = headerComponent;
          if(!Component)
            return <td onClick={event => this.handleTDClick({...scheme, index, event})} key={index}>{label}</td>;

          return <td onClick={event => this.handleTDClick({...scheme, index, event})} key={index}><Component {...scheme} sortColumn={sortColumn} /></td>;
        })}
      </tr>
      </thead>;
    }
}

GridHeaders.propTypes = {
  schema : PropTypes.array,
  onClick : PropTypes.func,
  onRowClick : PropTypes.func,
}

export default GridHeaders;



// WEBPACK FOOTER //
// ./src/browser/components/ui/table/gridHeaders.js